/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppBillboardRouteImport } from './routes/_app/billboard'
import { Route as AppCreateRouteImport } from './routes/_app/create'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppFriendsRouteImport } from './routes/_app/friends'
import { Route as AppHistoryRouteImport } from './routes/_app/history'
import { Route as AppShopRouteImport } from './routes/_app/shop'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as AppAdminCreateRouteImport } from './routes/_app/admin/create'
import { Route as AppAdminDemandRouteImport } from './routes/_app/admin/demand'
import { Route as AppAdminJobsRouteImport } from './routes/_app/admin/jobs'
import { Route as AppLibraryIndexRouteImport } from './routes/_app/library.index'
import { Route as AppLibraryMineRouteImport } from './routes/_app/library.mine'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsTabRouteImport } from './routes/_app/settings.$tab'
import { Route as AppTracksTrackIdRouteImport } from './routes/_app/tracks.$trackId'
import { Route as AppUHandleRouteImport } from './routes/_app/u.$handle'
import { Route as AppAdminPacksIndexRouteImport } from './routes/_app/admin/packs.index'
import { Route as AppAdminPacksPackIdRouteImport } from './routes/_app/admin/packs.$packId'
import { Route as AppAdminTracksIndexRouteImport } from './routes/_app/admin/tracks.index'
import { Route as AppAdminTracksTrackIdRouteImport } from './routes/_app/admin/tracks.$trackId'
import { Route as AppLibraryPacksPackIdRouteImport } from './routes/_app/library.packs.$packId'
import { Route as AppTracksTrackIdIndexRouteImport } from './routes/_app/tracks.$trackId.index'
import { Route as AppTracksTrackIdLyricsRouteImport } from './routes/_app/tracks.$trackId.lyrics'
import { Route as AppAdminTracksTrackIdIndexRouteImport } from './routes/_app/admin/tracks.$trackId.index'
import { Route as AppAdminTracksTrackIdLyricsRouteImport } from './routes/_app/admin/tracks.$trackId.lyrics'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppBillboardRoute = AppBillboardRouteImport.update({
  id: '/billboard',
  path: '/billboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCreateRoute = AppCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppFriendsRoute = AppFriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppShopRoute = AppShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => AppRoute,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminCreateRoute = AppAdminCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminDemandRoute = AppAdminDemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobsRoute = AppAdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppLibraryIndexRoute = AppLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryMineRoute = AppLibraryMineRouteImport.update({
  id: '/library/mine',
  path: '/library/mine',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTabRoute = AppSettingsTabRouteImport.update({
  id: '/settings/$tab',
  path: '/settings/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppTracksTrackIdRoute = AppTracksTrackIdRouteImport.update({
  id: '/tracks/$trackId',
  path: '/tracks/$trackId',
  getParentRoute: () => AppRoute,
} as any)
const AppUHandleRoute = AppUHandleRouteImport.update({
  id: '/u/$handle',
  path: '/u/$handle',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPacksIndexRoute = AppAdminPacksIndexRouteImport.update({
  id: '/packs/',
  path: '/packs/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPacksPackIdRoute = AppAdminPacksPackIdRouteImport.update({
  id: '/packs/$packId',
  path: '/packs/$packId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTracksIndexRoute = AppAdminTracksIndexRouteImport.update({
  id: '/tracks/',
  path: '/tracks/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTracksTrackIdRoute = AppAdminTracksTrackIdRouteImport.update({
  id: '/tracks/$trackId',
  path: '/tracks/$trackId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppLibraryPacksPackIdRoute = AppLibraryPacksPackIdRouteImport.update({
  id: '/library/packs/$packId',
  path: '/library/packs/$packId',
  getParentRoute: () => AppRoute,
} as any)
const AppTracksTrackIdIndexRoute = AppTracksTrackIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTracksTrackIdRoute,
} as any)
const AppTracksTrackIdLyricsRoute = AppTracksTrackIdLyricsRouteImport.update({
  id: '/lyrics',
  path: '/lyrics',
  getParentRoute: () => AppTracksTrackIdRoute,
} as any)
const AppAdminTracksTrackIdIndexRoute =
  AppAdminTracksTrackIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminTracksTrackIdRoute,
  } as any)
const AppAdminTracksTrackIdLyricsRoute =
  AppAdminTracksTrackIdLyricsRouteImport.update({
    id: '/lyrics',
    path: '/lyrics',
    getParentRoute: () => AppAdminTracksTrackIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/$': typeof AppSplatRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/billboard': typeof AppBillboardRoute
  '/create': typeof AppCreateRoute
  '/dashboard': typeof AppDashboardRoute
  '/friends': typeof AppFriendsRoute
  '/history': typeof AppHistoryRoute
  '/shop': typeof AppShopRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/admin/create': typeof AppAdminCreateRoute
  '/admin/demand': typeof AppAdminDemandRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/library/mine': typeof AppLibraryMineRoute
  '/settings/$tab': typeof AppSettingsTabRoute
  '/tracks/$trackId': typeof AppTracksTrackIdRouteWithChildren
  '/u/$handle': typeof AppUHandleRoute
  '/library/': typeof AppLibraryIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/packs/$packId': typeof AppAdminPacksPackIdRoute
  '/admin/tracks/$trackId': typeof AppAdminTracksTrackIdRouteWithChildren
  '/library/packs/$packId': typeof AppLibraryPacksPackIdRoute
  '/tracks/$trackId/lyrics': typeof AppTracksTrackIdLyricsRoute
  '/admin/packs/': typeof AppAdminPacksIndexRoute
  '/admin/tracks/': typeof AppAdminTracksIndexRoute
  '/tracks/$trackId/': typeof AppTracksTrackIdIndexRoute
  '/admin/tracks/$trackId/lyrics': typeof AppAdminTracksTrackIdLyricsRoute
  '/admin/tracks/$trackId/': typeof AppAdminTracksTrackIdIndexRoute
}
export interface FileRoutesByTo {
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/$': typeof AppSplatRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/billboard': typeof AppBillboardRoute
  '/create': typeof AppCreateRoute
  '/dashboard': typeof AppDashboardRoute
  '/friends': typeof AppFriendsRoute
  '/history': typeof AppHistoryRoute
  '/shop': typeof AppShopRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/': typeof AppIndexRoute
  '/admin/create': typeof AppAdminCreateRoute
  '/admin/demand': typeof AppAdminDemandRoute
  '/admin/jobs': typeof AppAdminJobsRoute
  '/library/mine': typeof AppLibraryMineRoute
  '/settings/$tab': typeof AppSettingsTabRoute
  '/u/$handle': typeof AppUHandleRoute
  '/library': typeof AppLibraryIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/admin/packs/$packId': typeof AppAdminPacksPackIdRoute
  '/library/packs/$packId': typeof AppLibraryPacksPackIdRoute
  '/tracks/$trackId/lyrics': typeof AppTracksTrackIdLyricsRoute
  '/admin/packs': typeof AppAdminPacksIndexRoute
  '/admin/tracks': typeof AppAdminTracksIndexRoute
  '/tracks/$trackId': typeof AppTracksTrackIdIndexRoute
  '/admin/tracks/$trackId/lyrics': typeof AppAdminTracksTrackIdLyricsRoute
  '/admin/tracks/$trackId': typeof AppAdminTracksTrackIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/billboard': typeof AppBillboardRoute
  '/_app/create': typeof AppCreateRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/friends': typeof AppFriendsRoute
  '/_app/history': typeof AppHistoryRoute
  '/_app/shop': typeof AppShopRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/create': typeof AppAdminCreateRoute
  '/_app/admin/demand': typeof AppAdminDemandRoute
  '/_app/admin/jobs': typeof AppAdminJobsRoute
  '/_app/library/mine': typeof AppLibraryMineRoute
  '/_app/settings/$tab': typeof AppSettingsTabRoute
  '/_app/tracks/$trackId': typeof AppTracksTrackIdRouteWithChildren
  '/_app/u/$handle': typeof AppUHandleRoute
  '/_app/library/': typeof AppLibraryIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/admin/packs/$packId': typeof AppAdminPacksPackIdRoute
  '/_app/admin/tracks/$trackId': typeof AppAdminTracksTrackIdRouteWithChildren
  '/_app/library/packs/$packId': typeof AppLibraryPacksPackIdRoute
  '/_app/tracks/$trackId/lyrics': typeof AppTracksTrackIdLyricsRoute
  '/_app/admin/packs/': typeof AppAdminPacksIndexRoute
  '/_app/admin/tracks/': typeof AppAdminTracksIndexRoute
  '/_app/tracks/$trackId/': typeof AppTracksTrackIdIndexRoute
  '/_app/admin/tracks/$trackId/lyrics': typeof AppAdminTracksTrackIdLyricsRoute
  '/_app/admin/tracks/$trackId/': typeof AppAdminTracksTrackIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/waitlist'
    | '/welcome'
    | '/$'
    | '/admin'
    | '/billboard'
    | '/create'
    | '/dashboard'
    | '/friends'
    | '/history'
    | '/shop'
    | '/sign-in/$'
    | '/admin/create'
    | '/admin/demand'
    | '/admin/jobs'
    | '/library/mine'
    | '/settings/$tab'
    | '/tracks/$trackId'
    | '/u/$handle'
    | '/library/'
    | '/settings/'
    | '/admin/packs/$packId'
    | '/admin/tracks/$trackId'
    | '/library/packs/$packId'
    | '/tracks/$trackId/lyrics'
    | '/admin/packs/'
    | '/admin/tracks/'
    | '/tracks/$trackId/'
    | '/admin/tracks/$trackId/lyrics'
    | '/admin/tracks/$trackId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/waitlist'
    | '/welcome'
    | '/$'
    | '/admin'
    | '/billboard'
    | '/create'
    | '/dashboard'
    | '/friends'
    | '/history'
    | '/shop'
    | '/sign-in/$'
    | '/'
    | '/admin/create'
    | '/admin/demand'
    | '/admin/jobs'
    | '/library/mine'
    | '/settings/$tab'
    | '/u/$handle'
    | '/library'
    | '/settings'
    | '/admin/packs/$packId'
    | '/library/packs/$packId'
    | '/tracks/$trackId/lyrics'
    | '/admin/packs'
    | '/admin/tracks'
    | '/tracks/$trackId'
    | '/admin/tracks/$trackId/lyrics'
    | '/admin/tracks/$trackId'
  id:
    | '__root__'
    | '/_app'
    | '/waitlist'
    | '/welcome'
    | '/_app/$'
    | '/_app/admin'
    | '/_app/billboard'
    | '/_app/create'
    | '/_app/dashboard'
    | '/_app/friends'
    | '/_app/history'
    | '/_app/shop'
    | '/sign-in/$'
    | '/_app/'
    | '/_app/admin/create'
    | '/_app/admin/demand'
    | '/_app/admin/jobs'
    | '/_app/library/mine'
    | '/_app/settings/$tab'
    | '/_app/tracks/$trackId'
    | '/_app/u/$handle'
    | '/_app/library/'
    | '/_app/settings/'
    | '/_app/admin/packs/$packId'
    | '/_app/admin/tracks/$trackId'
    | '/_app/library/packs/$packId'
    | '/_app/tracks/$trackId/lyrics'
    | '/_app/admin/packs/'
    | '/_app/admin/tracks/'
    | '/_app/tracks/$trackId/'
    | '/_app/admin/tracks/$trackId/lyrics'
    | '/_app/admin/tracks/$trackId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  WaitlistRoute: typeof WaitlistRoute
  WelcomeRoute: typeof WelcomeRoute
  SignInSplatRoute: typeof SignInSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billboard': {
      id: '/_app/billboard'
      path: '/billboard'
      fullPath: '/billboard'
      preLoaderRoute: typeof AppBillboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/create': {
      id: '/_app/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof AppCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/friends': {
      id: '/_app/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AppFriendsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shop': {
      id: '/_app/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof AppShopRouteImport
      parentRoute: typeof AppRoute
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/create': {
      id: '/_app/admin/create'
      path: '/create'
      fullPath: '/admin/create'
      preLoaderRoute: typeof AppAdminCreateRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/demand': {
      id: '/_app/admin/demand'
      path: '/demand'
      fullPath: '/admin/demand'
      preLoaderRoute: typeof AppAdminDemandRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/jobs': {
      id: '/_app/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AppAdminJobsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/library/': {
      id: '/_app/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof AppLibraryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/mine': {
      id: '/_app/library/mine'
      path: '/library/mine'
      fullPath: '/library/mine'
      preLoaderRoute: typeof AppLibraryMineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/$tab': {
      id: '/_app/settings/$tab'
      path: '/settings/$tab'
      fullPath: '/settings/$tab'
      preLoaderRoute: typeof AppSettingsTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracks/$trackId': {
      id: '/_app/tracks/$trackId'
      path: '/tracks/$trackId'
      fullPath: '/tracks/$trackId'
      preLoaderRoute: typeof AppTracksTrackIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/u/$handle': {
      id: '/_app/u/$handle'
      path: '/u/$handle'
      fullPath: '/u/$handle'
      preLoaderRoute: typeof AppUHandleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/packs/': {
      id: '/_app/admin/packs/'
      path: '/packs'
      fullPath: '/admin/packs/'
      preLoaderRoute: typeof AppAdminPacksIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/packs/$packId': {
      id: '/_app/admin/packs/$packId'
      path: '/packs/$packId'
      fullPath: '/admin/packs/$packId'
      preLoaderRoute: typeof AppAdminPacksPackIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/tracks/': {
      id: '/_app/admin/tracks/'
      path: '/tracks'
      fullPath: '/admin/tracks/'
      preLoaderRoute: typeof AppAdminTracksIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/tracks/$trackId': {
      id: '/_app/admin/tracks/$trackId'
      path: '/tracks/$trackId'
      fullPath: '/admin/tracks/$trackId'
      preLoaderRoute: typeof AppAdminTracksTrackIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/library/packs/$packId': {
      id: '/_app/library/packs/$packId'
      path: '/library/packs/$packId'
      fullPath: '/library/packs/$packId'
      preLoaderRoute: typeof AppLibraryPacksPackIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracks/$trackId/': {
      id: '/_app/tracks/$trackId/'
      path: '/'
      fullPath: '/tracks/$trackId/'
      preLoaderRoute: typeof AppTracksTrackIdIndexRouteImport
      parentRoute: typeof AppTracksTrackIdRoute
    }
    '/_app/tracks/$trackId/lyrics': {
      id: '/_app/tracks/$trackId/lyrics'
      path: '/lyrics'
      fullPath: '/tracks/$trackId/lyrics'
      preLoaderRoute: typeof AppTracksTrackIdLyricsRouteImport
      parentRoute: typeof AppTracksTrackIdRoute
    }
    '/_app/admin/tracks/$trackId/': {
      id: '/_app/admin/tracks/$trackId/'
      path: '/'
      fullPath: '/admin/tracks/$trackId/'
      preLoaderRoute: typeof AppAdminTracksTrackIdIndexRouteImport
      parentRoute: typeof AppAdminTracksTrackIdRoute
    }
    '/_app/admin/tracks/$trackId/lyrics': {
      id: '/_app/admin/tracks/$trackId/lyrics'
      path: '/lyrics'
      fullPath: '/admin/tracks/$trackId/lyrics'
      preLoaderRoute: typeof AppAdminTracksTrackIdLyricsRouteImport
      parentRoute: typeof AppAdminTracksTrackIdRoute
    }
  }
}

interface AppAdminTracksTrackIdRouteChildren {
  AppAdminTracksTrackIdLyricsRoute: typeof AppAdminTracksTrackIdLyricsRoute
  AppAdminTracksTrackIdIndexRoute: typeof AppAdminTracksTrackIdIndexRoute
}

const AppAdminTracksTrackIdRouteChildren: AppAdminTracksTrackIdRouteChildren = {
  AppAdminTracksTrackIdLyricsRoute: AppAdminTracksTrackIdLyricsRoute,
  AppAdminTracksTrackIdIndexRoute: AppAdminTracksTrackIdIndexRoute,
}

const AppAdminTracksTrackIdRouteWithChildren =
  AppAdminTracksTrackIdRoute._addFileChildren(
    AppAdminTracksTrackIdRouteChildren,
  )

interface AppAdminRouteChildren {
  AppAdminCreateRoute: typeof AppAdminCreateRoute
  AppAdminDemandRoute: typeof AppAdminDemandRoute
  AppAdminJobsRoute: typeof AppAdminJobsRoute
  AppAdminPacksPackIdRoute: typeof AppAdminPacksPackIdRoute
  AppAdminTracksTrackIdRoute: typeof AppAdminTracksTrackIdRouteWithChildren
  AppAdminPacksIndexRoute: typeof AppAdminPacksIndexRoute
  AppAdminTracksIndexRoute: typeof AppAdminTracksIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminCreateRoute: AppAdminCreateRoute,
  AppAdminDemandRoute: AppAdminDemandRoute,
  AppAdminJobsRoute: AppAdminJobsRoute,
  AppAdminPacksPackIdRoute: AppAdminPacksPackIdRoute,
  AppAdminTracksTrackIdRoute: AppAdminTracksTrackIdRouteWithChildren,
  AppAdminPacksIndexRoute: AppAdminPacksIndexRoute,
  AppAdminTracksIndexRoute: AppAdminTracksIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppTracksTrackIdRouteChildren {
  AppTracksTrackIdLyricsRoute: typeof AppTracksTrackIdLyricsRoute
  AppTracksTrackIdIndexRoute: typeof AppTracksTrackIdIndexRoute
}

const AppTracksTrackIdRouteChildren: AppTracksTrackIdRouteChildren = {
  AppTracksTrackIdLyricsRoute: AppTracksTrackIdLyricsRoute,
  AppTracksTrackIdIndexRoute: AppTracksTrackIdIndexRoute,
}

const AppTracksTrackIdRouteWithChildren =
  AppTracksTrackIdRoute._addFileChildren(AppTracksTrackIdRouteChildren)

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppBillboardRoute: typeof AppBillboardRoute
  AppCreateRoute: typeof AppCreateRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFriendsRoute: typeof AppFriendsRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppShopRoute: typeof AppShopRoute
  AppIndexRoute: typeof AppIndexRoute
  AppLibraryMineRoute: typeof AppLibraryMineRoute
  AppSettingsTabRoute: typeof AppSettingsTabRoute
  AppTracksTrackIdRoute: typeof AppTracksTrackIdRouteWithChildren
  AppUHandleRoute: typeof AppUHandleRoute
  AppLibraryIndexRoute: typeof AppLibraryIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppLibraryPacksPackIdRoute: typeof AppLibraryPacksPackIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppBillboardRoute: AppBillboardRoute,
  AppCreateRoute: AppCreateRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFriendsRoute: AppFriendsRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppShopRoute: AppShopRoute,
  AppIndexRoute: AppIndexRoute,
  AppLibraryMineRoute: AppLibraryMineRoute,
  AppSettingsTabRoute: AppSettingsTabRoute,
  AppTracksTrackIdRoute: AppTracksTrackIdRouteWithChildren,
  AppUHandleRoute: AppUHandleRoute,
  AppLibraryIndexRoute: AppLibraryIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppLibraryPacksPackIdRoute: AppLibraryPacksPackIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  WaitlistRoute: WaitlistRoute,
  WelcomeRoute: WelcomeRoute,
  SignInSplatRoute: SignInSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
